import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import SEO from "@/components/SEO";

export default function DatenschutzPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <SEO 
        title="Datenschutz | Personal Fußballtraining"
        description="Datenschutzerklärung von Fußballtraining Aktas. Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
        path="/datenschutz"
      />
      {/* Header */}
      <div className="bg-[#0A0A0A] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#c1ff72] transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="font-['Bebas_Neue'] text-4xl md:text-5xl text-white mb-8">
          Datenschutzerklärung
        </h1>

        <div className="prose prose-invert prose-lg max-w-none space-y-8">
          
          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">1. Verantwortlicher</h2>
            <p className="text-white/80">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="text-white/80 mt-4">
              Fußballtraining Aktas<br />
              Yasin Aktas<br />
              Unterm Hestenberg 2<br />
              58540 Meinerzhagen<br />
              E-Mail: <a href="mailto:kontakt@fussballtraining-aktas.de" className="text-[#c1ff72] hover:underline">kontakt@fussballtraining-aktas.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">2. Allgemeine Hinweise</h2>
            <p className="text-white/80">
              Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten Ihre Daten ausschließlich im Rahmen der gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">3. Hosting</h2>
            <p className="text-white/80">
              Diese Website wird über einen externen Hosting-Anbieter betrieben. Dabei werden technische Daten wie IP-Adresse, Browsertyp, Betriebssystem und Zugriffszeit verarbeitet, soweit dies zur Bereitstellung der Website erforderlich ist.
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">4. Kontaktaufnahme</h2>
            <p className="text-white/80">
              Wenn Sie uns per Kontaktformular oder E-Mail kontaktieren, werden die von Ihnen übermittelten Daten ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet.
            </p>
          </section>

          <section data-testid="privacy-sms-section">
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">4a. SMS-Benachrichtigungen zu Trainingsbuchungen</h2>
            <p className="text-white/80">
              Bei der Online-Buchung können Sie freiwillig eine Mobilfunknummer angeben und in SMS-Benachrichtigungen einwilligen. Wir senden dann ausschließlich Service-Nachrichten zu Ihrer Buchung: Eingang der Buchungsanfrage, Terminbestätigung, Absage sowie eine Erinnerung 24 Stunden vor dem Training. Werbe-SMS versenden wir nicht.
            </p>
            <p className="text-white/80 mt-4">
              Verarbeitet werden Mobilfunknummer, Termindaten sowie Zeitpunkt und Wortlaut Ihrer Einwilligung (Nachweis). Rechtsgrundlage ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Für den Versand nutzen wir den Dienstleister Twilio Inc. (USA) als Auftragsverarbeiter; die Übermittlung erfolgt auf Grundlage des EU-U.S. Data Privacy Framework bzw. der EU-Standardvertragsklauseln.
            </p>
            <p className="text-white/80 mt-4">
              Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, über <Link to="/sms-abmeldung" className="text-[#c1ff72] hover:underline">SMS abbestellen</Link> oder per E-Mail an die oben genannte Adresse. Die Buchung ist auch ohne Mobilnummer und SMS-Einwilligung möglich. Die Daten werden gelöscht, sobald sie für die Buchung nicht mehr erforderlich sind, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>
          </section>


          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">5. Server-Logfiles</h2>
            <p className="text-white/80">
              Beim Besuch der Website werden automatisch Informationen erhoben und in Server-Logfiles gespeichert. Hierzu gehören unter anderem:
            </p>
            <ul className="list-disc list-inside text-white/80 mt-4 space-y-2">
              <li>IP-Adresse</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Browsertyp</li>
              <li>Betriebssystem</li>
              <li>Aufgerufene Seiten</li>
            </ul>
            <p className="text-white/80 mt-4">
              Diese Daten dienen der technischen Bereitstellung und Sicherheit der Website.
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">6. Cookies</h2>
            <p className="text-white/80">
              Unsere Website verwendet technisch notwendige Cookies. Soweit darüber hinaus Cookies zu Analyse- oder Marketingzwecken eingesetzt werden, erfolgt dies nur mit Ihrer Einwilligung.
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">7. Ihre Rechte</h2>
            <p className="text-white/80">Sie haben das Recht auf:</p>
            <ul className="list-disc list-inside text-white/80 mt-4 space-y-2">
              <li>Auskunft über Ihre gespeicherten Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung Ihrer Daten</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
              <li>Widerspruch gegen die Verarbeitung</li>
              <li>Beschwerde bei einer Datenschutzaufsichtsbehörde</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">8. SSL-/TLS-Verschlüsselung</h2>
            <p className="text-white/80">
              Diese Website nutzt eine SSL-/TLS-Verschlüsselung, um die Übertragung vertraulicher Inhalte zu schützen.
            </p>
          </section>

          <section>
            <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mb-4">9. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-white/80">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, sofern dies aufgrund gesetzlicher Änderungen oder neuer Funktionen unserer Website erforderlich wird.
            </p>
          </section>

        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#71717A] text-sm">
            © {new Date().getFullYear()} Fußballtraining Aktas
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
